import { styled } from '@linaria/react';

export const IconImage = styled.img<{ size: number }>`
  width: ${({ size }) => size || 16}px;
  height: ${({ size }) => size || 16}px;
  object-fit: contain;
  border-radius: 50%;
`;
